import React, { useEffect, useState } from "react";
import { api, formatCurrency } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function SuperAdminTickets() {
  const [tickets, setTickets] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/superadmin/tickets?limit=500").then((r) => setTickets(r.data)); }, []);
  const filtered = tickets.filter((t) => !q || [t.ticket_number, t.customer_firstname, t.customer_name, t.customer_phone, t.company_name].filter(Boolean).some((v) => v.toLowerCase().includes(q.toLowerCase())));

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl font-bold">Billets — toutes agences</h1>
          <p className="text-sm text-slate-500">{tickets.length} billets sur toute la plateforme</p>
        </div>
        <div className="relative min-w-[240px]">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input placeholder="N° billet, client, agence…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" data-testid="sa-tickets-search" />
        </div>
      </div>
      <Card>
        <CardContent className="p-0 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs uppercase text-slate-500 border-b border-slate-200 dark:border-slate-800">
              <tr><th className="text-left p-3">N°</th><th className="text-left">Agence</th><th className="text-left">Trajet</th><th className="text-left">Client</th><th className="text-left">Date</th><th className="text-left">Canal</th><th className="text-right p-3">Total</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
              {filtered.map((t) => (
                <tr key={t.id} data-testid={`sa-ticket-${t.ticket_number}`}>
                  <td className="p-3 font-mono text-xs">{t.ticket_number}</td>
                  <td className="text-xs">{t.company_name || "—"}</td>
                  <td>{t.from_city} → {t.to_city}</td>
                  <td className="text-xs">{t.customer_firstname} {t.customer_name}<div className="text-slate-500">{t.customer_phone}</div></td>
                  <td className="text-xs">{t.date} {t.schedule}</td>
                  <td><span className="text-xs px-2 py-0.5 rounded-full bg-slate-100 dark:bg-slate-800">{t.channel || "menu"}</span></td>
                  <td className="p-3 text-right font-semibold">{formatCurrency(t.total)}</td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={7} className="p-8 text-center text-slate-500">Aucun billet</td></tr>}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}
